import { defineStore } from "pinia"
import { apiV1 } from "@/config/axios"

/**
 * @deprecated The connections store wraps the legacy `/analytic-connections` API.
 * New code should use the connector store (`src/store/connectors.js`) and the
 * `/connectors/*` endpoints introduced in V2.
 * This store is kept for backward compatibility with the DocumentsList mass-
 * analytics workflow and will be removed when that workflow is migrated.
 */
export const useConnectionsStore = defineStore("connections", {
  state: () => ({
    error: null,
    activeConnectionsCache: new Map()
  }),
  actions: {
    /**
     * Fetch the list of analytical lists available for filtering.
     * @deprecated Prefer fetching nomenclatures via the nomenclatures store.
     */
    async fetchAnalyticalLists(params = {}) {
      this.error = null
      try {
        const response = await apiV1.get("/hub-analytical-lists", { params })
        return response.data
      } catch (error) {
        this.error = error.response?.data?.message || error.message
        throw error
      }
    },

    /**
     * Fetch active analytic connections for a specific document.
     * @deprecated Use connector-based endpoints (`/connectors/{connector}/accounts`)
     *             in conjunction with the account mapping system introduced in V2.
     *             Kept for backward compatibility with the mass-analytics workflow.
     */
    async fetchAnalyticConnectionsForDocument(documentId, documentTypeId) {
      const params = {}
      if (documentTypeId) {
        params.document_type_id = documentTypeId
      }

      try {
        const response = await apiV1.get(
          `/analytic-connections/for-document/${documentId}`,
          { params }
        )
        const cacheKey = `${documentId}_${documentTypeId || "null"}`
        this.activeConnectionsCache.set(cacheKey, response.data)
        return response.data
      } catch (error) {
        this.error = error.response?.data?.message || error.message
        throw error
      }
    },

    /**
     * Retrieve cached active connections for a document.
     * @deprecated See fetchAnalyticConnectionsForDocument.
     */
    getActiveConnectionsForDocument(documentId, documentTypeId) {
      const cacheKey = `${documentId}_${documentTypeId || "null"}`
      return this.activeConnectionsCache.get(cacheKey)?.data || []
    }
  }
})
